import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIconButton from 'Src/components/buttons/CloseIconButton';
import Copy from 'Src/components/Copy';
import { HeaderMainNav } from 'Src/components/navigation/HeaderMainNav';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';
import useRoute from 'Src/routes/useRoute';

const SplitPayment: FC = () => {
  const { t } = useTranslation();
  const { navigate } = useRoute();

  const onClose = () => navigate(-1);

  return (
    <Page
      main={(
        <PageMain
          header={(
            <PageMainHeader
              start={(
                <>
                  <CloseIconButton onClick={onClose} />
                  <Copy variant="h6" value={t('splitPayment.label')} />
                </>
              )}
              end={<HeaderMainNav />}
            />
          )}
          main={<Copy variant="h6" color="warning" align="center" value={'Payment / Split Payment / COMING SOON'} />}
        />
      )}
    />
  );
};

export default SplitPayment;
